import { Field } from "./FormField";
import {
  ValidatorResponseType,
  ValidatorResponse
} from "~/workera/utils/typedForms/validators/common/ValidatorResponse";

export class FormDescription {
  fields: Field<any>[];

  constructor(formFields: Field<any>[]) {
    this.fields = formFields;
  }

  private flattenValidators(
    validatorResponseOne: ValidatorResponse,
    validatorResponseTwo: ValidatorResponse
  ): ValidatorResponse {
    if (validatorResponseOne.isError()) {
      return validatorResponseOne;
    }

    if (validatorResponseTwo.isError()) {
      return validatorResponseTwo;
    }

    if (validatorResponseOne.isError()) {
      return validatorResponseOne;
    }

    if (validatorResponseTwo.isWarning()) {
      return validatorResponseTwo;
    }

    return new ValidatorResponse(
      ValidatorResponseType.SUCCESS,
      validatorResponseOne.message.concat(validatorResponseTwo.message)
    );
  }

  validate() {
    return this.fields
      .map(field => field.validate())
      .reduce(this.flattenValidators);
  }
}
